import React from "react";
import { useTranslation } from "react-i18next";
import { IconChecked, IconClose } from "icons";
import { SleekToggle } from "components/Sleek/SleekToggle";

interface SelectMultipleButtonProps {
  isActive: boolean;
  onClick: () => void;
}

// The multi-select toggle, shared across filter bars, in the Trends pages' finish (2026-10-26: `SleekToggle`). The
// caller's onClick owns the state reset + analytics (the event name differs per surface).
const SelectMultipleButton = ({ isActive, onClick }: SelectMultipleButtonProps) => {
  const { t } = useTranslation();

  return <SleekToggle active={isActive} onClick={onClick} icon={isActive ? <IconClose className="h-4 w-4" /> : <IconChecked className="h-4 w-4" />} label={t("assets:_shared.select_multiple")} />;
};

export default SelectMultipleButton;
